module.exports = __webpack_public_path__ + "static/media/New_LOGO.624c2884.svg";